import React from 'react';
const CustomModal = ({ isOpen, onClose, children, customStyle }) => {
     if (!isOpen) return null;
     return (
          <div style={styles.overlay}>
               <div style={{ ...styles.modal, ...customStyle }}>
                    <button style={styles.closeButton} onClick={onClose}>
                         &times;
                    </button>
                    {children}
               </div>
          </div>
     );
};
const styles = {
     overlay: {
          position: 'fixed',
          top: '0',
          left: 0,
          width: '100%',
          height: '80%',
          minHeight: '90vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
     },
     modal: {
          background: '#eeeeee',
          padding: '20px',
          borderRadius: '8px',
          maxWidth: '90%',
          minWidth: '300px',
          maxHeight: '100%',
          boxShadow: '0 5px 20px rgba(0, 0, 0, 0.1)',
          position: 'relative',
          overflowY: 'auto',
          border: '1px solid #c2c0c0',
     },
     closeButton: {
          position: 'absolute',
          top: '5px',
          right: '5px',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer',
          display: 'block',
          padding: '0 ',
     },
     '@media (max-width: 768px)': {
          overlay: {
               marginTop: '5rem',
          },
          modal: {
               minWidth: '90%',
               padding: '10px',
          },
     },
};
export default CustomModal;
